import React from 'react'
import {graphql} from "gatsby";
import parse from 'html-react-parser';
import { StructuredText } from 'react-datocms';

const BasicPage = ({ title, richContent, theme }) => {
  return (
    <>
      <section className={`title-header${theme ? ` ${theme}` : ''}`}>
        <div className='title-header__inner'>
          {title && <h1 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h1>}
        </div>
      </section>
      <section className={`basic-page${theme ? ` ${theme}` : ''}`}>
        <div className='basic-page__inner'>
          {richContent && <div className='basic-page__content'><StructuredText data={richContent} /></div>}
        </div>
      </section>
    </>
  )
}

export default BasicPage

export const query = graphql`
  fragment BasicPageProps on DatoCmsBasicPage {
    ... on DatoCmsBasicPage {
      title
      richContent {
        value
      }
    }
  }
`